// Validation UX (formulaires Particulier + Transport Interurbain + inscription
// expéditeur) — n'affecte pas la validation backend des colonnes partagées
// destinataire_tel/expediteur_tel utilisées par tous les autres parcours.
export const CAMEROON_PHONE_REGEX = /^(\+?237)?6[0-9]{8}$/;

export function isValidCameroonPhone(phone: string): boolean {
  return CAMEROON_PHONE_REGEX.test(phone.replace(/\s/g, ''));
}

/**
 * Accepte un numéro local camerounais (6XXXXXXXX / +2376XXXXXXXX) OU un numéro
 * international au format E.164 (+ indicatif pays + 6 à 14 chiffres).
 * Utilisé là où le destinataire peut être à l'étranger (spéc. MAJ 06/09/26 —
 * « validation du format local/international »).
 */
export function isValidPhone(phone: string): boolean {
  const cleaned = phone.replace(/[\s.-]/g, '');
  if (isValidCameroonPhone(cleaned)) return true;
  // International E.164 : +[indicatif][national], 8 à 15 chiffres au total.
  return /^\+[1-9]\d{7,14}$/.test(cleaned);
}

/** true si le numéro relève du Cameroun (indicatif +237 ou numéro local). */
export function isCameroonNumber(phone: string): boolean {
  const d = phone.replace(/\D/g, '');
  return d.startsWith('237') || /^[26]\d{8}$/.test(d);
}
